module.exports = __webpack_public_path__ + "img/home-fabres-orbis-01.2917c3ae.svg";